import React, { createRef } from "react";
import Media from "react-media";
import './ChooseProductCategories.css';
import { HeaderDesktop } from "../../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../../components/header/mobile/HeaderMobile";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import { MposWebPortalApi } from "../../../services/api/MposWebPortalApi";
import { ChooseCategoriesState } from "../../../states/ChooseCategoriesState";
import { ServiceUnavailablePage } from "../../service-unavailable-page/ServiceUnavailablePage";
import { Button, FormControlLabel, TextField } from "@material-ui/core";
import { AppUtils } from "../../../utils/AppUtils";
import { Route } from "react-router-dom";
import { CustomCheckbox } from "../../../components/checkbox/Checkbox";
import _ from "lodash";
import { CategoryDto, ICategoryDto } from "../../../models/CategoryDto";
import { Pagination } from "../../../utils/Pagination";
import { IProductDto, ProductDto } from "../../../models/ProductDto";
import { MposLoader } from "../../../components/loader/MposLoader";
import { ProductsDto } from "../../../models/ProductsDto";
import { UpdateProductCategoriesDto } from "../../../models/UpdateProductCategoriesDto";
import $ from 'jquery';

export class ChooseProductCategories extends React.Component<any, ChooseCategoriesState> {
    readonly MAX_CATEGORY_NAME_LENGTH = 30;
    private newCategoryInputRef: any = null;
    private pagination: Pagination<ICategoryDto>;
    constructor(props: any){
        super(props);
        this.state = {
            productName: null,
            productDescription: null,
            productAmount: null,
            productImage: null,
            productImageName: null,
            productImageType: null,
            isLoading: false,
            isError: false,
            categories: null,
            nCategories: 0,
            newCategoryName: "",
            selectedCategories: [],
            selectedCategoriesCounter: 0,
            categoryToShow: null,
            showLoader: false,
            isUpdate: false,
            toUpdate: null,
            oldsCategories: [],
            pathToReturn: "/catalog",
            choosenPrevCategory: undefined,
            categoryNameRemainingLength: this.MAX_CATEGORY_NAME_LENGTH
        }

        this.newCategoryInputRef = createRef();
        this.handleCreateNewCategoryKeyDown = this.handleCreateNewCategoryKeyDown.bind(this);
        this.handleCreateNewCategoryChanges = this.handleCreateNewCategoryChanges.bind(this);
        this.pagination = new Pagination(5);
    }

    componentDidMount(){
        GoogleTagManagerService.getInstance().pushInteractionEvent('popupImpression', 'Popup', 'impression', 'catalogo prodotti: creazione prodotto: inserimento categoria');
        if(this.props.location.state === undefined){
            console.log("[ChooseProductCategories] Error for missing params!");
            this.props.history.replace('/catalog');
        } else {
            const { data } = this.props.location.state;
            console.log("[ChooseProductCategories] " + JSON.stringify(data));
            if(data === undefined){
                console.log("[ChooseProductCategories] Error for missing params!");
                this.props.history.replace('/catalog');
            } else {
                if(data.update){
                    console.log("[ChooseProductCategories] is update");
                    let toUpdate: IProductDto = data.product;
                    let olds = data.olds;
                    let pathToReturn = data.pathToReturn;
                    if(pathToReturn !== undefined){
                        this.setState({pathToReturn: pathToReturn});
                    }
                    this.setState({oldsCategories: JSON.parse(olds)});
                    this.setState({isUpdate: true});
                    this.setState({toUpdate: toUpdate});
                    this.setState({selectedCategories: (toUpdate.categories === null || toUpdate.categories === undefined) ? [] : toUpdate.categories!}, () => {
                        this.setState({selectedCategoriesCounter: this.state.selectedCategories.length});
                    })
                } else {
                    console.log("[ChooseProductCategories] Not update but new!");
                    this.setState({isUpdate: false});
                    this.setState({productName: data.productName});
                    this.setState({productAmount: data.productPrice});
                    this.setState({productDescription: (data.productDescription !== undefined && data.productDescription !== "") ? data.productDescription : null});
                    this.setState({productImage: (data.image !== undefined && data.image !== "") ? data.image : null}, () => {
                        if(this.state.productImage !== null){
                            this.setState({productImageName: data.imageName});
                            this.setState({productImageType: data.imageType});
                        }
                    });
                }
                this.setState({isLoading: true});
                MposWebPortalApi.getInstance().getCategories().subscribe(response => {
                    this.setState({isLoading: false});
                    this.setState({isError: false});
                    this.setState({categories: (response.categories !== undefined && response.categories !== null) ? this.sortCategories(response.categories) : []}, () => {
                        this.setState({nCategories: this.getCategoriesNumber(response.categories!!)});
                        this.pagination.setInputData(this.sortCategories(response.categories!!));
                        this.getCategoriesToShow();
                        this.setState({choosenPrevCategory: this.props.choosenCategory}, () => {
                            console.log("[ChooseProductCategories] from " + JSON.stringify(this.state.choosenPrevCategory));
                            if(this.state.choosenPrevCategory !== undefined){
                                let selected = this.state.selectedCategories;
                                selected.push(this.state.choosenPrevCategory);
                                this.setState({selectedCategories: selected}, () => {
                                    this.setState({selectedCategoriesCounter: this.state.selectedCategories.length});
                                })
                            }
                        });
                    });
                }, () => {
                    this.setState({isLoading: false});
                    this.setState({categories: null});
                    this.setState({isError: true});
                    this.setState({nCategories: 0});
                })
            }
        }

        window.scrollTo(0, 0);
    }

    private handleCreateNewCategoryKeyDown(event: any){
        if(AppUtils.isPhoneOrTablet()){
            if (event.key === 'Enter') {
                console.log("[ChooseProductCategories] Done clicked!");
                if(this.newCategoryInputRef !== undefined){
                    this.newCategoryInputRef.current.blur();
                }
            }
        }
    }

    private handleCreateNewCategoryChanges(event: any){
        if(event.target.value.length <= 30){
            this.setState({newCategoryName: event.target.value});
            let computedLength = this.MAX_CATEGORY_NAME_LENGTH - event.target.value.length;
            this.setState({categoryNameRemainingLength: computedLength});
        } else {
            event.preventDefault();
        }
    }

    private onCheckedElement(event: any, value: ICategoryDto){
        console.log("[ChooseProductCategories] " + event.target.checked + " element: " + JSON.stringify(value));
        if(event.target.checked){
            this.addToList(value);
        } else {
            this.removeToList(value);
        }
    }

    private addToList(value: ICategoryDto){
        let temp = this.state.selectedCategories;
        temp.push(value);
        this.setState({selectedCategories: temp}, () => {
            this.setState({selectedCategoriesCounter: this.state.selectedCategories.length});
        });
    }

    private removeToList(value: ICategoryDto){
        let temp = this.state.selectedCategories;
        let index = _.indexOf(temp, _.find(temp, (category: ICategoryDto) => {
            return category.categoryId === value.categoryId;
        }));
        if(index > -1){
            temp.splice(index, 1);
        }
        this.setState({selectedCategories: temp}, () => {
            this.setState({selectedCategoriesCounter: this.state.selectedCategories.length});
        });
    }

    private sortCategories(categories: ICategoryDto[]){
        if(categories !== null && categories !== undefined){
            let sorted = categories!!.sort(function(a, b){
                if(a.name != null && b.name != null){
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                }

                return 0;
            })

            let index = _.indexOf(sorted, _.find(sorted, (value: ICategoryDto) => {
                return value.name?.toLowerCase() === 'senza categoria';
            }))

            if (index > -1) {
                sorted.splice(index, 1);
                return sorted;
            } else {
                return sorted;
            }
        }

        return [];
    }

    private getCategoriesToShow(){
        this.setState({categoryToShow: this.pagination.getNext()});
    }

    private getCategoriesNumber(categories: ICategoryDto[]): number {
        if(categories !== null && categories !== undefined){
            let index = _.indexOf(categories, _.find(categories, (value: ICategoryDto) => {
                return value.name?.toLowerCase() === 'senza categoria';
            }))
    
            if(index !== -1){
                return categories.length - 1;
            } else {
                return categories.length;
            }
        }
        
        return 0;
    }

    private addProduct(history: any){
        console.log("[ChooseProductCategories] addProduct");
        this.setState({showLoader: true});
        let categories = this.state.selectedCategories;
        if(this.state.newCategoryName !== ""){
            console.log("[ChooseProductCategories] create new category");
            // create new category with only name
            let category = new CategoryDto(null, null, this.state.newCategoryName, null);
            categories.push(category);
        }
        let productDto = new ProductDto(this.state.productAmount, categories, this.state.productDescription, 
            this.state.productImage, this.state.productImageType, this.state.productName, null, this.state.productImageName, null);
        let products = new ProductsDto();
        products.products.push(productDto);
        MposWebPortalApi.getInstance().addProduct(products).subscribe((result) => {
            if(result){
                this.setState({showLoader: false});
                history.push('/result', {
                    isCatalog: true,
                    isSuccess: true,
                    title: "Hai inserito un nuovo prodotto nel tuo catalogo!",
                    button: "CREA NUOVO PRODOTTO",
                    data: { from: "ChooseProductCategories", operation: "addProduct", productName: this.state.productName }
                })
            } else {
                // show error page
                this.setState({showLoader: false});
                history.push('/result', {
                    isSuccess: false,
                    errorTitle: "Si è verificato un errore durante la creazione del prodotto.",
                    message: "Riprova più tardi. Grazie per la pazienza",
                    button: "TORNA AL CATALOGO",
                    data: { from: "CatalogPage", operation: "addProduct" }
                })
            }
        }, (error) => {
            // show error page
            this.setState({showLoader: false});
            history.push('/result', {
                isSuccess: false,
                errorTitle: "Si è verificato un errore durante la creazione del prodotto.",
                message: "Riprova più tardi. Grazie per la pazienza",
                button: "TORNA AL CATALOGO",
                data: { from: "CatalogPage", operation: "addProduct" }
            })
        });
    }

    private updateProduct(history: any){
        console.log("[ChooseProductCategories] updateProduct");
        // Update categories
        this.setState({showLoader: true});
        // Product
        let product: IProductDto = this.state.toUpdate!;
        // New categories
        //@ts-ignore
        let temporaryToAdd = [];
        if(product.categories !== null && product.categories !== undefined){
            temporaryToAdd = _.map(product.categories, (value) => {
                return value.categoryId;
            });
        }
       
        // Old categories 
        let temporaryToRemove = _.map(this.state.oldsCategories, (value) => {
            return value.categoryId;
        });
        // Get interseption
        //@ts-ignore
        const common = temporaryToAdd.filter(value => temporaryToRemove.includes(value));
        for(let i = 0; i < common.length; i++){
            let el = common[i];
            //@ts-ignore
            temporaryToAdd = temporaryToAdd.filter((value) => !(value === el));
            temporaryToRemove = temporaryToRemove.filter((value) => !(value === el));
        }
        let newCategory = null;
        if(this.state.newCategoryName !== undefined && this.state.newCategoryName !== undefined && this.state.newCategoryName !== ""){
            newCategory = this.state.newCategoryName;
        }
        //@ts-ignore
        let updateCategoriesDto = new UpdateProductCategoriesDto(temporaryToAdd, temporaryToRemove, newCategory);
        MposWebPortalApi.getInstance().updateProductCategories(product.productId!, updateCategoriesDto).subscribe((response) => {
            this.setState({showLoader: false});
            history.push('/result', {
                isSuccess: true,
                title: "Hai modificato le categorie di appartenenza del tuo prodotto!",
                message: "",
                button: "TORNA AL PRODOTTO",
                data: { from: "ChooseProductCategories", operation: "updateProduct", product: product }
            })
        }, () => {
            history.push('/result', {
                isSuccess: false,
                errorTitle: "Si è verificato un errore durante la modifica delle categorie del prodotto.",
                message: "Riprova più tardi. Grazie per la pazienza",
                button: "TORNA AL PRODOTTO",
                data: { from: "ChooseProductCategories", operation: "updateProduct", product: product }
            })
        })
    }

    isChecked(value: ICategoryDto): boolean {
        let index = _.indexOf(this.state.selectedCategories, _.find(this.state.selectedCategories, (category: ICategoryDto) => {
            return category.name?.toLowerCase() === value.name?.toLowerCase();
        }))

        if(index !== -1){
            return true;
        } else {
            return false;
        }
    }

    private hideHelperText(input: string){
        $('#' + input).css('visibility', 'hidden');
    }

    private showHelperText(input: string){
        $('#' + input).css('visibility', 'visible');
    }

    render(){
        return this.state.isError ? <ServiceUnavailablePage/> : <div id={"main-container-choose-categories"}>
            <Media query="(max-width: 1064px)" render={() => {
                return <HeaderMobile showBack={true} showLogout={false} showTitle={true} title={this.state.isUpdate ? "Modifica categorie" : "Crea prodotto"} showClose={this.state.isUpdate ? false : true} 
                closePage={this.state.isUpdate ? this.state.pathToReturn : '/catalog'} returnState={{image: this.state.toUpdate?.image, type: this.state.toUpdate?.imageType}}/>
            }}/>
            <Media query="(min-width: 1065px)" render={() => {
                return <HeaderDesktop showBack={true} showLogout={false} showTitle={true} title={this.state.isUpdate ? "Modifica categorie" : "Crea prodotto"} showClose={this.state.isUpdate ? false : true} 
                closePage={this.state.isUpdate ? this.state.pathToReturn : '/catalog'} returnState={{image: this.state.toUpdate?.image, type: this.state.toUpdate?.imageType}}/>
            }}/>
            {!this.state.isLoading ? <div id={"choose-categories-details-content"}>
                <p className={"choose-categories-title"}>Scegli le categorie dove inserire il prodotto (opzionale)</p>
                {
                    this.state.nCategories === 0 ? <div className={"choose-categories-categories-list"}>
                        <p className={"choose-categories-no-categories"}>Non hai ancora creato nessuna categoria.</p>
                    </div> : <div className={"choose-categories-categories-list"}>
                        <p className={"choose-categories-total-label"}>
                            {
                                (this.state.categories?.length!! > 1) ? ["Hai selezionato ", <strong>{this.state.selectedCategoriesCounter}</strong>, " di " + this.state.nCategories + " categorie"] :
                                ["Hai selezionato ", <strong>{this.state.selectedCategoriesCounter}</strong>, " di " + this.state.nCategories + " categoria"]
                            }
                        </p>
                        <div className={"choose-categories-categories-list-content"} id={"choose-categories-categories-list-content"} style={{width: (document.getElementsByClassName('choose-categories-categories-list')[0] as any).offsetWidth < 348 ? (document.getElementsByClassName('choose-categories-categories-list')[0] as any).offsetWidth : 348}}>
                            {
                                _.map(this.state.categoryToShow, (value: ICategoryDto) => {
                                    return <div className={"choose-categories-checkbox-container"}>
                                        <CustomCheckbox label={value.name!!} onChange={(event) => this.onCheckedElement(event, value)} value={value} checked={this.isChecked(value)} />
                                    </div>
                                })
                            }
                        </div>
                        {this.pagination.hasMoreElements() && 
                            <div className={"choose-category-button-container-show-more"}><Button id={"choose-categories-show-more"} onClick={() => {this.getCategoriesToShow()}} disableRipple>{"Mostra di più".toUpperCase()}</Button></div>}
                    </div> 
                }
                <div className={"choose-categories-row"}></div>
                <div className={"choose-categories-add-new"}>
                    <p className={"choose-categories-add-new-title"}>Oppure inserisci una nuova categoria</p>
                    <TextField id={"choose-categories-add-textfield"} label="Crea nome categoria" type={"text"}
                        onChange={this.handleCreateNewCategoryChanges}
                        onKeyDown={this.handleCreateNewCategoryKeyDown}
                        inputRef={this.newCategoryInputRef}
                        inputProps={{ maxLength: this.MAX_CATEGORY_NAME_LENGTH }}
                        value={this.state.newCategoryName}
                        helperText={"-" + this.state.categoryNameRemainingLength}
                        onFocus={() => this.showHelperText('choose-categories-add-textfield-helper-text')}
                        onBlur={() => this.hideHelperText('choose-categories-add-textfield-helper-text')}
                    />
                </div>
                {!this.state.isLoading && <div className={"choose-categories-next-container"} style={{marginTop: this.state.nCategories > 0 ? '70px' : '170px'}}>
                    <Route render={({history}) => {
                        return <Button id={"choose-categorie-button-next"} disabled={false} onClick={() => {
                            // Callback to call add product
                            this.state.isUpdate ? this.updateProduct(history) : this.addProduct(history);
                        }}>{this.state.isUpdate ? "CONFERMA" : "AVANTI"}</Button>;
                    }}/>
                </div>}
                {
                // @ts-ignore
                <MposLoader show={this.state.showLoader}/>
                }
            </div> : null /* create skeleton */}
        </div>
    }
}